import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import failedImg from '../../../assets/images/error.svg'
import Button from '../../../components/Button'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import { procedureComplete } from '../../../redux/actions'

const NominativityFailed = () => {
  const { setBlockNavigation }: any = useAppContext()
  const history = useHistory()

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onContinue = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/nominatividad')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <div className="landing-container">
        <img src={failedImg} alt="activation failed" style={{ height: '150px' }} />
        <h3>
          <strong>
            Algo salió mal en la <br /> activación de tu Chip
          </strong>
        </h3>
        <p className="error-sugest">
          Por favor ingresá más tarde en la <br /> bandeja &quot;En curso&quot; y finalizá el trámite. <br />
          Si el problema persiste reportá <br /> el caso al *46872
        </p>
        <Button
          id="nominativity-failed-back-to-start"
          className="link-button"
          label="Ir al Inicio"
          handleSubmit={onContinue}
        />
      </div>
    </main>
  )
}

export default NominativityFailed
